
export default function()
{
    PIXI.glCore.GLTexture.prototype.upload = function(source)
    {
        this.bind();

        var gl = this.gl;

        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);

        var isVideo = !!source.videoWidth;
        var newWidth = isVideo ? source.videoWidth : source.width;
        var newHeight = isVideo ? source.videoHeight : source.height;

        if(newHeight !== this.height || newWidth !== this.width || isVideo)
        {
            gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, this.type, source);
        }
        else
        {
            gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, this.format, this.type, source);
        }

        this.width = newWidth;
        this.height = newHeight;

    }

    let tickerPrototype = Object.getPrototypeOf(PIXI.ticker.shared)
    tickerPrototype.remove = function(fn, context)
    {
        let listener = this._head.next;

        while (listener)
        {
            // We found a match, lets remove it
            // no break to delete all possible matches
            // incase a listener was added 2+ times
            if (listener.match(fn, context))
            {
                //https://github.com/pixijs/pixi.js/pull/4234
                //ошибка в TickerListener.destroy, но, так как мы не можем получить доступ к прототипу TickerListener,
                //внесем аналогичные изменения в прототип PIXI.Ticker
                var redirect = listener.next;
                listener.destroy();
                listener.next = redirect;
                listener = redirect;
            }
            else
            {
                listener = listener.next;
            }
        }

        if (!this._head.next)
        {
            this._cancelIfNeeded();
        }

        return this;
    }
}




// WEBPACK FOOTER //
// ./src/library/PIXI_video_performance_fix.es6